import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { LogoutAction } from '../enums/logout-action.enum';
import { AuthService } from '../services/auth.service';

@Injectable()
export class LogoutGuard implements CanActivate {
	/**
	 * Constructor
	 */
	constructor(private authService: AuthService, private cookieService: CookieService, private router: Router) {}

	/**
	 * Can activate
	 *
	 * @param route
	 * @param state
	 * @return
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return new Observable<boolean>((subscriber) => {
			this.authService.loggedIn(false, false).subscribe((loggedIn) => {
				// Process logout action
				const action: LogoutAction = route.params['action'];
				switch (action) {
					case LogoutAction.SECURITY:
						this.securityAction();
						break;
					case LogoutAction.TIMEOUT:
						this.timeoutAction();
						break;
					case LogoutAction.EXPIRED:
						this.expiredAction();
						break;
				}

				// Logout
				this.authService.logout().subscribe();

				// If you want to show logout page set next = true
				subscriber.next(false);
				subscriber.complete();
			});
		});
	}

	/**
	 * Security logout
	 */
	securityAction() {
		this.cookieService.set('securityLogout', 'true', 0, '/');
	}

	/**
	 * Timeout logout
	 */
	timeoutAction() {
		this.cookieService.set('timeoutLogout', 'true', 0, '/');
	}

	/**
	 * Expired logout
	 */
	expiredAction() {
		this.cookieService.set('expiredLogout', 'true', 0, '/');
	}
}
